export const accountMenuItems = [
    { to: "usuario", label: "Datos de usuario" },
    { to: "direcciones", label: "Direcciones" },
    { to: "Pedidos", label: "Pedidos" },
    { to: "Facturas", label: "Facturas" },
    { to: "Favoritos", label: "Favoritos" },
    { to: "Alertas", label: "Alertas y notificaciones" },
    { to: "pendientes", label: "Productos pendientes" },
];
